import {
  enGB as enGbLocale,
  nl as nlLocale,
  sv as svLocale,
} from "date-fns/locale";
import type { Locale } from "date-fns";

import en from "../core/translations/en.json";
import sv from "../core/translations/sv.json";
import nl from "../core/translations/nl.json";

export const supportedLanguages = ["en", "nl", "sv"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const resources: Record<SupportedLanguage, { translation: unknown }> = {
  en: {
    translation: { ...en },
  },
  sv: {
    translation: { ...sv },
  },
  nl: {
    translation: { ...nl },
  },
};

export const locales = {
  en: enGbLocale,
  nl: nlLocale,
  sv: svLocale,
};

// check browser locale.
export const getLocale = (): SupportedLanguage => {
  const currentLanguage = navigator.language.split("-")[0];
  if ((supportedLanguages as ReadonlyArray<string>).includes(currentLanguage)) {
    return currentLanguage as SupportedLanguage;
  }
  return "en";
};

export const getDateFnsLocale = (): Locale => {
  const locale = getLocale();
  return locales[locale];
};
